<template>
	<div>
		<v-row no-gutters class="d-flex flex-row justify-space-between px-12">
			<v-col cols="12" md="8" class="text-center text-md-left">


				<div class="text-md-h4 text-h5 font-weight-bold  text-center text-md-start">
					Earn Free Rewards
				</div>


				<div class="text-body-1 font-weight-thin mt-2">
					Exchange points for games, skins, game currency and other valuable
					rewards
				</div>


			</v-col>
			<v-col cols="12" md="2">


				<button @click="redirectToEarn()" class="button--secondary rounded-pill mt-3 px-8 py-3  mx-auto d-flex">
					Start Earning
				</button>


			</v-col>
		</v-row>
		<v-row no-gutters class="mt-12" v-if="authStore.isUserLoggedIn()">
			<v-col cols="12">
				<div class="free-rewards__carousel-container">


					<div>
						<v-btn class="  rounded-pill free-rewards__arrow-btn-left pa-0" color="arrowButton"
							@click="previousItem">
							<left-arrow />
						</v-btn>
					</div>


					<div>
						<v-btn class="  rounded-pill free-rewards__arrow-btn-right pa-0" color="arrowButton"
							@click="nextItem">
							<right-arrow />
						</v-btn>
					</div>


					<div class="free-rewards__carousel-wrapper"
						:style="{ transform: 'translateX(' + -100 * windowModel + '%)' }">
						<div class="free-rewards__carousel__item d-flex flex-row justify-center"
							v-for="carouselIndex in n" :key="carouselIndex">
							<div v-for="taskIndex in getTaskIndices(carouselIndex - 1)" :key="taskIndex">


								<InHouseTaskSquareTile :name="filteredTaskData[taskIndex].name"
									:id="String(filteredTaskData[taskIndex].id)" style="width: 240px !important;" class="mx-2">
								</InHouseTaskSquareTile>


							</div>
						</div>


						<InHouseTaskDialogs></InHouseTaskDialogs>


						<div v-if="totalTiles === 0">
							<p>You have no more bonus tasks available today.</p>
							<p>Come back tomorrow for more bonus tasks.</p>
						</div>

					</div>
				</div>
			</v-col>
		</v-row>
	</div>
</template>



<script lang="ts">

import { computed, ref } from 'vue';
import { useDisplay } from "vuetify";
import { useRouter } from 'vue-router';

import { scrollToTop } from "@/utils/utils";
import { useAuthStore } from "@/store/AuthStore";
import LeftArrow from "@/icons/LeftArrow.vue";
import RightArrow from "@/icons/RightArrow.vue";
import { UserActivityStore } from "@/store/UserActivityStore";
import InHouseTaskDialogs from "../Earn/Dialogs/InHouse-Task-Dialogs.vue";
import InHouseTaskSquareTile from "@/components/Tiles/Earn/InHouse-Task-Square-Tile.vue";


export default {
	name: "FreeRewards",
	components: {
		LeftArrow,
		RightArrow,
		InHouseTaskDialogs,
		InHouseTaskSquareTile,
	},
	setup() {
		const windowModel = ref(0);
		const router = useRouter();
		const display = useDisplay();
		const authStore = useAuthStore();
		const inHouseTaskStore = UserActivityStore();

		const totalTiles = computed(() => {
			let a = inHouseTaskStore.inHouseTasks;
			let b = Object.values(a);
			let c = b.length;
			return c;
		});

		const m = computed(() => {
			const name = display.name.value;
			switch (name) {
				case "xs":
					return 1;
				case "sm":
					return 2;
				case "md":
					return 3;
				case "lg":
					return 3;
				case "xl":
					return 4;
				case "xxl":
					return 6;
				default:
					return 4;
			}
		});

		const n = computed(() => {
			let a = totalTiles.value / m.value;
			let b = Math.ceil(a);
			return b;
		});

		const filteredTaskData = computed(() => Object.values(inHouseTaskStore.inHouseTasks));

		const previousItem = () => {
			if (windowModel.value > 0) {
				windowModel.value--;
			} else {
				windowModel.value = n.value - 1;
			}
		};

		const nextItem = () => {
			if (windowModel.value < n.value - 1) {
				windowModel.value++;
			} else {
				windowModel.value = 0;
			}
		};

		const redirectToEarn = () => {
			router.push({ path: "/earn" });
			scrollToTop();
		};

		const getTaskIndices = (carouselIndex: number) => {
			// This should start at 0 for the first iteration
			const startIndex = carouselIndex * m.value;
			const endIndex = Math.min(startIndex + m.value, totalTiles.value);
			let a = Array.from({ length: endIndex - startIndex }, (_, i) => startIndex + i);
			return a;
		};


		return {
			n,
			m,
			nextItem,
			authStore,
			totalTiles,
			windowModel,
			previousItem,
			getTaskIndices,
			redirectToEarn,
			filteredTaskData,
		};
	},
};
</script>
